import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=3285dac2&"
import script from "./declaration.vue?vue&type=script&lang=js&"
export * from "./declaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports